module.exports = __webpack_public_path__ + "img/orange-rectangle-table-6.97049674.png";